export default {
  label: 'Tags',
  placeholder: 'Todos',
};
